export default __webpack_public_path__ + "static/media/brand-logo.1845e182.png";